import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { MvrReportDetails } from '@core/models/api/response/uw-reports-response.model';

@Component({
    selector: 'nwx-mvr-report-details',
    templateUrl: './mvr-report-details.component.html',
    styleUrls: ['./mvr-report-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MvrReportDetailsComponent implements OnInit {
  @Input() reportDetails!: MvrReportDetails[];

  constructor() {}

  ngOnInit(): void {}
}
